import { render, staticRenderFns } from "./ClientAlertRenewExpiredDate.vue?vue&type=template&id=3f85d426&scoped=true&"
import script from "./ClientAlertRenewExpiredDate.vue?vue&type=script&lang=js&"
export * from "./ClientAlertRenewExpiredDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85d426",
  null
  
)

export default component.exports